export const LicenseInfoDataGrid = {
    license: "80014de3201f4c8353bfecb10e3ba4bbTz03MzcyOSxFPTE3MjUwMzA1MzkwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=" // Data in https://materia.atlassian.net/wiki/spaces/D/pages/1376471/Proyecto+DLyS
}

// Clave utilizada para el consumo de la API de Google Drive
export const accessKey = "AIzaSyDZ6hH50ScBqGoOQOMUD2AVNKpPfkBaSOI" // Data in https://materia.atlassian.net/wiki/spaces/D/pages/1376471/Proyecto+DLyS

if (localStorage.getItem("clientData") === null) {
    localStorage.setItem(
        "clientData",
        JSON.stringify({
            owner_code: "",
            dominio: "",
            api_pass: "",
        })
    );
}

export const configS3 = {
    bucketName: JSON.parse(localStorage.getItem("siam-params-images"))?.BUCKET_NAME?.value ? JSON.parse(localStorage.getItem("siam-params-images"))?.BUCKET_NAME?.value : '',
    region: 'us-east-1', // Región global de S3 
    accessKeyId: JSON.parse(localStorage.getItem("siam-params-images"))?.PUBLIC_KEY?.value ? JSON.parse(localStorage.getItem("siam-params-images"))?.PUBLIC_KEY?.value : '',
    secretAccessKey: JSON.parse(localStorage.getItem("siam-params-images"))?.PRIVATE_KEY?.value ? JSON.parse(localStorage.getItem("siam-params-images"))?.PRIVATE_KEY?.value : ''
};

export const config = {
    credentials: {
        authorization: {
            owner_code: JSON.parse(localStorage.getItem("clientData")).owner_code,
            id_user: "2",
            language: "es",
        },
    },
    authToken: localStorage.getItem("authToken"),
};

export const appName = JSON.parse(localStorage.getItem("clientData")).owner_descripcion

export const id_proyecto = "24"

export const parametros_proyecto = [
    { id: "24", nombre: "Cartocor", usar_video_login: false, url_video: false, usar_imagen_login: true, url_imagen: 'https://siam-srv.krakenlab.com.ar/static_content/img/CARTOCOR_LOGO.png', codigo_iso_moneda: "ARS", aws_url_clave_firma: "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_zx7mv8wN7", aws_id_cliente_aplicacion: "360pds86tsnq2rmug2d3g0djhk", aws_id_grupo_user: 'us-east-1_zx7mv8wN7', aws_iam_accessKeyId: 'AKIASIOYXQSFJLSQ2RG2', aws_iam_secretAccessKey: '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', key_encript: 'a1b2c3d4e5f678901234567890abcdefa1b2c3d4e5f678901234567890abcdef', use_cognito: true}
]
